<template>
    <div class="ny">
        <div class="main">
             <div class="hy_k mh">
                  <div class="bt mh md10">{{$myStore.state.RealName}}</div>
                  <div class="nr mh md30">尊敬的用户，欢迎您登录天津市华夏器官移植救助基金会 成人亲体移植医疗救助申请审批系统！</div>
                  <div class="anq mh">
                       <el-button type="primary an_r left" @click="open_page('/user/usersuc_sq1')">我要申请</el-button>
                       <el-button type="info left" @click="open_page('/user/usersplist')">查看已申请记录</el-button>
                  </div>
             </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
 export default {
  data() {
    return {
    
      }
  },
  methods: {
   
  },
  created: function () {
    // this.$emit('header', false);
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/user/Userhome.vue